import { ChartBar, Microphone, FileText, type Icon as PhosphorIcon } from '@phosphor-icons/react'

export type ActivityKind = 'analysis' | 'recording' | 'transcription'

export interface ActivityConfig {
  label: string
  icon: PhosphorIcon
  processingColor: string
  completedColor: string
  processingGradient: string
  completedGradient: string
  processingShadow: string
  completedShadow: string
  glowColor: string
  shimmerEnabled: boolean
  progressMessages: { delay: number; text: string }[]
  estimatedDuration: number
}

export const ACTIVITY_CONFIGS: Record<ActivityKind, ActivityConfig> = {
  analysis: {
    label: 'Analyse',
    icon: ChartBar,
    processingColor: 'var(--bn-accent)',
    completedColor: '#10b981',
    processingGradient: 'linear-gradient(135deg, rgba(10,10,15,0.95), rgba(15,15,20,0.95))',
    completedGradient: 'linear-gradient(135deg, rgba(6,78,59,0.95), rgba(4,47,36,0.98))',
    processingShadow: '0 4px 20px rgba(0,0,0,0.5), 0 0 0 1px rgba(168,85,247,0.15), inset 0 1px 0 rgba(255,255,255,0.03)',
    completedShadow: '0 4px 24px rgba(16,185,129,0.3), 0 0 0 1px rgba(16,185,129,0.25), inset 0 1px 0 rgba(255,255,255,0.05)',
    glowColor: 'rgba(168,85,247,',
    shimmerEnabled: true,
    progressMessages: [
      { delay: 0, text: 'Lecture du transcript...' },
      { delay: 8, text: 'Analyse des échanges...' },
      { delay: 20, text: 'Scoring découverte...' },
      { delay: 40, text: 'Évaluation objections...' },
      { delay: 60, text: 'Scripts correctifs...' },
      { delay: 80, text: 'Scénario de closing...' },
      { delay: 100, text: 'Construction checklist...' },
      { delay: 120, text: 'Finalisation...' },
    ],
    estimatedDuration: 180,
  },
  recording: {
    label: 'Enregistrement',
    icon: Microphone,
    processingColor: '#ef4444',
    completedColor: '#10b981',
    processingGradient: 'linear-gradient(135deg, rgba(20,8,8,0.95), rgba(15,10,10,0.95))',
    completedGradient: 'linear-gradient(135deg, rgba(6,78,59,0.95), rgba(4,47,36,0.98))',
    processingShadow: '0 4px 20px rgba(0,0,0,0.5), 0 0 0 1px rgba(239,68,68,0.15), inset 0 1px 0 rgba(255,255,255,0.03)',
    completedShadow: '0 4px 24px rgba(16,185,129,0.3), 0 0 0 1px rgba(16,185,129,0.25), inset 0 1px 0 rgba(255,255,255,0.05)',
    glowColor: 'rgba(239,68,68,',
    shimmerEnabled: false,
    progressMessages: [{ delay: 0, text: 'Enregistrement...' }],
    estimatedDuration: 0,
  },
  transcription: {
    label: 'Transcription',
    icon: FileText,
    processingColor: '#3b82f6',
    completedColor: '#10b981',
    processingGradient: 'linear-gradient(135deg, rgba(8,12,20,0.95), rgba(10,14,22,0.95))',
    completedGradient: 'linear-gradient(135deg, rgba(6,78,59,0.95), rgba(4,47,36,0.98))',
    processingShadow: '0 4px 20px rgba(0,0,0,0.5), 0 0 0 1px rgba(59,130,246,0.15), inset 0 1px 0 rgba(255,255,255,0.03)',
    completedShadow: '0 4px 24px rgba(16,185,129,0.3), 0 0 0 1px rgba(16,185,129,0.25), inset 0 1px 0 rgba(255,255,255,0.05)',
    glowColor: 'rgba(59,130,246,',
    shimmerEnabled: true,
    progressMessages: [
      { delay: 0, text: 'Envoi audio...' },
      { delay: 5, text: 'Transcription en cours...' },
      { delay: 30, text: 'Reconnaissance vocale...' },
      { delay: 60, text: 'Finalisation...' },
    ],
    estimatedDuration: 90,
  },
}

export const FLASH_OVERRIDES: Partial<ActivityConfig> = {
  progressMessages: [
    { delay: 0, text: 'Lecture du transcript...' },
    { delay: 8, text: 'Analyse rapide...' },
    { delay: 20, text: 'Scoring...' },
    { delay: 40, text: 'Finalisation...' },
  ],
  estimatedDuration: 60,
}
